import { render } from "./SeccionDatos.vue?vue&type=template&id=012dbdf4"
import script from "./SeccionDatos.vue?vue&type=script&lang=js"
export * from "./SeccionDatos.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__